import React from 'react';
import Button from '../../components/Buttons/Button';
import PageHeader from '../../components/Headers/Pageheaders';
import '../Services/styles.css';

const sections = [
  {
    img: '../images/gallery/home/1.jpg',
    text: `Welcome and congratulations on your engagement. I'm Amy. I've been in the hair industry for over 20 years now having worked alongside some of the most influential stylists in London and at various shows. I've always had a flare and passion for wedding hair—I just love to style brides (and squad) for their special days.`,
  },
  {
    img: '../images/gallery/home/2.jpg',
    text: `Based in Colchester, I cover the Essex and Suffolk areas and am a proudly recommended supplier at the beautifully idyllic Prested Hall and East Mersea Hall.`,
  },
  {
    img: '../images/gallery/home/3.jpg',
    text: `Whether you're planning a grand celebration or an intimate gathering, I tailor each style to reflect your personality and vision.`,
  },
  {
    img: '../images/gallery/home/4.jpg',
    text: `I always ensure a calm, joyful experience on your wedding morning, helping you feel confident and radiant.`,
  },
  {
    img: '../images/gallery/home/5.jpg',
    text: `Let me be part of your love story. Enquire below today to begin your bridal hair journey.`,
  },
];

const Section = ({ img, text, reverse }) => (
  <div className={`section ${reverse ? 'reverse' : ''}`}>
    <div className="section-image">
      <img src={img} alt="Wedding hair" />
    </div>
    <div className="section-text">
      <p>{text}</p>
    </div>
  </div>
);

const EnquireButton = () => {
  return <Button link="/email" text="ENQUIRE" isFilled />
}

export default function Header() {
  return (
    <>
      <section className="wedding-header">
        <PageHeader title="RHAPSODY BRIDAL HAIR" />
        {sections.map((s, i) => (
          <Section key={i} img={s.img} text={s.text} reverse={i % 2 !== 0} />
        ))}
        <EnquireButton />
        <div style={{ marginBottom: '10px' }} />
      </section>
    </>
  );
}